(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["share-button"] && !Shopify.designMode) return;
  try {
    class ShareProductButton extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.trigger = this.querySelector('[ref="trigger"]');
      this.feedback = this.querySelector('[ref="feedback"]');
      this.trigger?.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.trigger?.removeEventListener('click', this.handleClick);
    }

    async handleClick() {
      const url = this.dataset.shareUrl;
      const title = this.dataset.shareTitle;
      const shareData = { title, url };

      if (navigator.share) {
        try {
          await navigator.share(shareData);
          return;
        } catch (err) {
          if (err && err.name === 'AbortError') return;
        }
      }

      await this.copyToClipboard(url);
    }

    async copyToClipboard(url) {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(url);
        } else {
          const input = document.createElement('input');
          input.value = url;
          input.setAttribute('readonly', '');
          input.style.position = 'absolute';
          input.style.left = '-9999px';
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);
        }
        this.showFeedback();
      } catch (err) {
        console.error('Share copy failed', err);
      }
    }

    showFeedback() {
      if (!this.feedback) return;
      this.feedback.textContent = this.dataset.copiedText;
      this.feedback.hidden = false;
      this.feedback.setAttribute('data-visible', 'true');
      clearTimeout(this.feedbackTimer);
      this.feedbackTimer = setTimeout(() => {
        this.feedback.removeAttribute('data-visible');
        this.feedback.hidden = true;
      }, 2000);
    }
  }

  if (!customElements.get('share-product-button')) {
    customElements.define('share-product-button', ShareProductButton);
  }
  } catch(e) { console.error(e); }
})();

})();
